// extracted by mini-css-extract-plugin
export default {"my_devices__wrapper":"styles_my_devices__wrapper__Tduuc","my_devices__table":"styles_my_devices__table__0Fkau"};